/*
  Race number card pairing (Oct 2026).

  A personalised jersey line and its £5 "Race Number Card" add-on line share a
  hidden _rc_id property (see snippets/race-card-personaliser.liquid). Whenever
  the cart changes, this makes sure every carded jersey has exactly one add-on
  at the same quantity, and removes add-ons whose jersey has gone, so a card
  can't be dropped to dodge the charge or be left behind after the jersey is
  removed. Quantity + remove controls are hidden on those lines in the cart
  templates; this is the backstop.
*/
(function () {
  const cfg = window.RaceCardCart;
  if (!cfg || !cfg.variantId) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_RE = /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/;
  let busy = false;
  let queued = false;

  async function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;
    try {
      const cart = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
      const jerseys = {};
      const cards = {};
      cart.items.forEach(item => {
        const id = item.properties && item.properties._rc_id;
        if (!id) return;
        if (item.variant_id === cfg.variantId) (cards[id] = cards[id] || []).push(item);
        else jerseys[id] = item;
      });

      const updates = {};
      const adds = [];
      Object.entries(cards).forEach(([id, list]) => {
        const jersey = jerseys[id];
        list.forEach((card, i) => {
          const want = jersey && i === 0 ? jersey.quantity : 0;
          if (card.quantity !== want) updates[card.key] = want;
        });
      });
      Object.entries(jerseys).forEach(([id, jersey]) => {
        if (cards[id]) return;
        const p = jersey.properties;
        adds.push({
          id: cfg.variantId,
          quantity: jersey.quantity,
          properties: {
            For: [jersey.variant_options && jersey.variant_options.join(' / '), p['Race Card Name'], '#' + p['Race Card Number'], p['Race Card Position']].filter(Boolean).join(' · '),
            _rc_id: id
          }
        });
      });

      if (!Object.keys(updates).length && !adds.length) return;
      if (Object.keys(updates).length) {
        await nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
      if (adds.length) {
        await nativeFetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: adds })
        });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      // Network hiccup: the next cart change or page load retries.
    } finally {
      busy = false;
      if (queued) { queued = false; reconcile(); }
    }
  }

  // Watch the theme's own cart calls (drawer qty/remove, cart page, upsells)
  // without touching each component: run a reconcile after any cart mutation.
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = String((input && input.url) || input || '');
    const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    const p = nativeFetch(input, init);
    if (method === 'POST' && CART_RE.test(url.split('#')[0]) && !busy && !cfg.paused) {
      p.then(() => setTimeout(reconcile, 50), () => {});
    }
    return p;
  };

  // The size grid pauses this while it posts a jersey + card pair, then calls it.
  cfg.reconcile = reconcile;
  if (cfg.check) reconcile();
})();
